import type { ApiError } from "@/shared/types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  FetchParcelsPayload,
  FetchParcelsSuccessPayload,
  ParcelsState,
} from "./types";

export const PARCELS_PAGE_SIZE = 9;

const initialState: ParcelsState = {
  items: [],
  filter: "all",
  page: 1,
  pageSize: PARCELS_PAGE_SIZE,
  totalPages: 1,
  totalRecords: 0,
  isLoading: true,
  isLoadingMore: false,
  error: null,
};

export const parcelsSlice = createSlice({
  name: "parcels",
  initialState,
  reducers: {
    /**
     * Saga trigger. Page 1 means "the filter changed" and clears the grid;
     * anything higher is a "load more" and leaves what is on screen alone.
     */
    fetchParcels: (state, action: PayloadAction<FetchParcelsPayload>) => {
      const first = action.payload.page <= 1;
      state.filter = action.payload.filter;
      state.error = null;
      if (first) {
        state.isLoading = true;
        state.isLoadingMore = false;
        state.page = 1;
      } else {
        state.isLoadingMore = true;
      }
    },

    fetchParcelsSuccess: (
      state,
      action: PayloadAction<FetchParcelsSuccessPayload>
    ) => {
      const { data, append } = action.payload;
      state.items = append ? [...state.items, ...data.content] : data.content;
      state.page = data.page;
      state.pageSize = data.pageSize;
      state.totalPages = data.totalPages;
      state.totalRecords = data.totalRecords;
      state.isLoading = false;
      state.isLoadingMore = false;
      state.error = null;
    },

    fetchParcelsFailure: (state, action: PayloadAction<ApiError>) => {
      state.isLoading = false;
      state.isLoadingMore = false;
      state.error = action.payload;
    },
  },
});

export const { actions: parcelsActions, reducer: parcelsReducer } =
  parcelsSlice;
